// extracted by mini-css-extract-plugin
export default {"filesList":"FilesList_filesList__I1RUa","itemData":"FilesList_itemData__yK-Fa","fa":"FilesList_fa__so0M1"};